import React from "react";

const BuyTickets = () => {
  return (
    <div className="container mx-auto py-8">
      <h1>Buy Tickets</h1>
    </div>
  );
};

export default BuyTickets;
